// 2024 Savage Attacker (SRD 5.2 Origin feat): once per turn when you hit a target with a weapon, roll the
// weapon's damage dice twice and use either roll. The higher roll is always the better choice, so it applies
// automatically; the once-per-turn use is claimed on the server like other turn-limited hit features.
export const SAVAGE_ATTACKER_FEATURE_ID = 'feat:savage-attacker';

const featKey = (feat) => String(feat?.featName ?? feat ?? '').trim().toLowerCase();
export const hasSavageAttacker = (character) => (Array.isArray(character?.feat) ? character.feat : []).some((feat) => featKey(feat) === 'savage attacker');

const ineligible = (reasonCode) => ({ status: 'ineligible', featureId: SAVAGE_ATTACKER_FEATURE_ID, featureLabel: 'Savage Attacker', reasonCode });

export const evaluateSavageAttacker = (context) => {
  if (!context?.attack?.isWeaponAttack) return ineligible('not-weapon-attack');
  const combat = context.combat || {};
  if (!combat.campaignId || !Number.isInteger(combat.turnSequence) || !combat.activeCombatantId) return ineligible('no-authoritative-turn');
  const previous = combat.turnFeatureUsage?.[context.attacker?.combatantId]?.[SAVAGE_ATTACKER_FEATURE_ID];
  if (previous?.turnSequence === combat.turnSequence && previous.resolutionId !== context.resolutionId) return ineligible('already-used-this-turn');
  return {
    status: 'automatic',
    featureId: SAVAGE_ATTACKER_FEATURE_ID,
    featureLabel: 'Savage Attacker',
    reasonCode: 'weapon-hit',
    // No added dice: the weapon roller rolls its own dice twice when this feature is confirmed.
    modifiesRoll: true,
    components: [],
    claims: [{
      campaignId: combat.campaignId,
      combatantId: context.attacker.combatantId,
      featureId: SAVAGE_ATTACKER_FEATURE_ID,
      turnSequence: combat.turnSequence,
      resolutionId: context.resolutionId,
    }],
  };
};
